import React from 'react';

// Reusable info tooltip. Hover or keyboard-focus the (i) icon to reveal an
// explainer. Placed beside section titles to explain what/when/why for that
// section. Pure CSS reveal (group-hover / group-focus-within) — no state, so it
// renders safely under renderToString (smoke tests) and SSR.
export default function InfoTooltip({ text, label = 'More info' }) {
  return (
    <span className="relative inline-flex items-center group align-middle">
      <button
        type="button"
        aria-label={label}
        className="flex items-center justify-center w-4 h-4 rounded-full bg-gray-300 text-white text-[10px] font-bold leading-none hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-primary/40 cursor-help"
      >
        i
      </button>
      <span
        role="tooltip"
        className="pointer-events-none absolute left-1/2 bottom-full z-20 mb-2 w-60 -translate-x-1/2 rounded-lg bg-gray-900 px-3 py-2 text-xs font-normal leading-snug text-white opacity-0 shadow-lg transition-opacity duration-150 group-hover:opacity-100 group-focus-within:opacity-100"
      >
        {text}
      </span>
    </span>
  );
}
